import React, { useEffect, useState } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IndoZambiaBankHighlightsSectorSupport = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Highlights Strong Sector Support at Annual Delivery Day</h1>

                    <p className="pb-3"><b>𝐈𝐧𝐝𝐨 𝐙𝐚𝐦𝐛𝐢𝐚 𝐁𝐚𝐧𝐤 𝐇𝐢𝐠𝐡𝐥𝐢𝐠𝐡𝐭𝐬 𝐒𝐭𝐫𝐨𝐧𝐠 𝐒𝐞𝐜𝐭𝐨𝐫 𝐒𝐮𝐩𝐩𝐨𝐫𝐭 𝐚𝐭 𝐀𝐧𝐧𝐮𝐚𝐥 𝐃𝐞𝐥𝐢𝐯𝐞𝐫𝐲 𝐃𝐚𝐲</b></p>

                    <p className="pb-3">Indo Zambia Bank participated in the flagship Annual Delivery Day hosted by the Presidential Delivery Unit, where the Bank showcased its sector achievements to Republican President Mr. Hakainde Hichilema, underscoring its commitment to Zambia's development priorities.</p>

                    <p className="pb-3">The Bank reported significant progress across agriculture, energy, health and SME development. Through the Sustainable Agriculture Financing Facility (SAFF), the Bank financed K410.8 million in crop production for over 7,000 farmers and K131.2 million for irrigation and mechanisation, benefiting over 10,000 farmers. Indo Zambia Bank also contributed K1 billion to national food security and invested K4 billion in the agri‑business value chain.</p>

                    <p className="pb-3">In the energy sector, the Bank financed over K2 billion, supporting initiatives that added 600MW to the national grid, Zambia's first Green City in Chadiza, over 200MW in renewable energy and the country's first biofuel projects. Additional sector support includes K339.28 million for mining, K65.52 million for health and K108.28 million for education.</p>

                    <p className="pb-3">The Bank continues empowering SMEs through MSME Loans, CDF Empowerment Loans, targeted support for women and youth and the Indo CDF Multiplier Programme.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #AnnualDeliveryDay #SectorSupport #Agriculture #Energy #EconomicDevelopment #Zambia #SMEEmpowerment</em></b></p>

                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0619.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0600.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0607.jpg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0608.jpg" />
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IndoZambiaBankHighlightsSectorSupport;
